export function clearWizardDrafts(targetWizardId?: string) {
  if (typeof window === 'undefined') return;

  const prefix = targetWizardId ? `onboard:${targetWizardId}` : 'onboard:';

  const clearFrom = (store: Storage) => {
    try {
      const toDelete: string[] = [];

      for (let i = 0; i < store.length; i++) {
        const k = store.key(i);
        if (k && k.startsWith(prefix)) toDelete.push(k);
      }

      toDelete.forEach((k) => store.removeItem(k));
    } catch {
      // ignore failures
    }
  };

  clearFrom(window.localStorage);
  clearFrom(window.sessionStorage);
}

export function makeWizardId(
  email?: string | null,
  workspaceSlug?: string | null,
) {
  const e = email || 'anon';
  const ws = workspaceSlug || 'no-ws';
  return `${e}:${ws}`;
}
